import React, { useEffect, useState, useRef } from "react";
import Select from "react-select";
//import ImageWithBasePath from "../../img/imagewithbasepath"; // Corrected the import path typo
// import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { set_page_refresh } from "../../redux/action";
import countriesData from '../../json/countries.json'; 

const UpdateSupplierModal = () => {
  const dispatch = useDispatch();
  const l = useSelector((state) => state.language || "en");
  const t = useSelector((state) => state.translation || "en");
  const data = useSelector((state) => state.supplier_edit);
  const [supplier, setSupplier] = useState({ country: "" });
  const closeRef = useRef(null);
  const closeRef2 = useRef(null);
  const countriesOptions = countriesData;
   
  useEffect(() => {
    const handleHidden = () => {
      setSupplier({ country: "" });
    };

    const modalElement = document.getElementById("add-units");
    modalElement?.addEventListener("hidden.bs.modal", handleHidden);

    return () => {
      modalElement?.removeEventListener("hidden.bs.modal", handleHidden);
    };
  }, []);

  useEffect(() => {
    if (data) {
      const { _id, name, address, city, email, contactNo, country, description } = data;
      setSupplier({ _id, name, address, city, email, contactNo, country, description });
    }
  }, [data]);

  const submit = async (event) => {
    const form = event.currentTarget;

    event.preventDefault();
    event.stopPropagation();

    try {
      if (form?.checkValidity()) {
        let result = await axios.post("addsupplier/", supplier);
        document.querySelector(".modal-backdrop").classList.toggle("show");
        dispatch(set_page_refresh("suppliers"));
        setSupplier({ country: "" });
        form.reset();
        closeRef.current?.click();
        closeRef2.current?.click();
        console.log(result);
      } else {
        return false;
      }
    } catch (e) {
      console.log(e);
      return false;
    }

    return true;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSupplier((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  return (
    <div>

      {/* Edit Supplier */}

      <div className="modal fade" id="edit-units">
        <div className="modal-dialog modal-dialog-centered custom-modal-two">
          <div className="modal-content">
            <div className="page-wrapper-new p-0">
              <div className="content">
                <div className="modal-header border-0 custom-modal-header">
                  <div className="page-title">
                    <h4>{t?.[l]?.["edit_supplier"] || "Edit Supplier"}</h4>
                  </div>
                  <button
                    type="button"
                    className="close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    ref={closeRef2}
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body custom-modal-body">
                  <form onSubmit={submit}>
                    <div className="row">
                      <div className="col-lg-12 hidden">
                        <div className="new-employee-field">
                          <span>Avatar</span>
                          <div className="profile-pic-upload edit-pic">
                            <div className="profile-pic">
                              {/* <span>
                                <ImageWithBasePath
                                  src="assets/img/supplier/edit-supplier.jpg"
                                  alt
                                />
                              </span> */}
                              <div className="close-img">
                                <i data-feather="x" className="info-img" />
                              </div>
                            </div>
                            <div className="input-blocks mb-0">
                              <div className="image-upload mb-0">
                                <input type="file" />
                                <div className="image-uploads">
                                  <h4>Change Image</h4>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="input-blocks">
                          <label>{t?.[l]?.["supplier_name"] || "Supplier Name"}</label>
                          <input
                            type="text"
                            placeholder="Apex Computers"
                            value={supplier.name || ""}
                            required
                            name="name"
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="input-blocks">
                          <label>{t?.[l]?.["email"] || "Email"}</label>
                          <input
                            type="email"
                            placeholder="apexcomputers@example.com"
                            value={supplier.email || ""}
                            required
                            name="email"
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="input-blocks">
                          <label>{t?.[l]?.["phone"] || "Phone"}</label>
                          <input
                            type="text"
                            placeholder={+12163547758}
                            value={supplier.contactNo || ""}
                            required
                            name="contactNo"
                            onInput={(e) => {
                              e.target.value = e.target.value.replace(/\D/g, "");
                            }}
                            maxLength={15}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="input-blocks">
                          <label>{t?.[l]?.["address"] || "Address"}</label>
                          <input
                            type="text"
                            value={supplier.address || ""}
                            name="address"
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-sm-10 col-10">
                        <div className="input-blocks">
                          <label>{t?.[l]?.["city"] || "City"}</label>
                          <input
                            value={supplier.city || ""}
                            type="text"
                            name="city"
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-sm-10 col-10">
                        <div className="input-blocks">
                          <label>{t?.[l]?.["country"] || "Country"}</label>
                          <Select
                            className="select"
                            options={countriesOptions}
                            name="country"
                            placeholder={t?.[l]?.["choose"] || "Choose"}
                            value={countriesOptions.find(option => option.value === supplier.country)}
                            onChange={(v) => {
                              handleInputChange({ target: { name: "country", value: v.value } });
                            }}
                          />
                        </div>
                      </div>
                      <div className="mb-0 input-blocks">
                        <label className="form-label">{t?.[l]?.["descriptions"] || "Descriptions"}</label>
                        <textarea
                          className="form-control mb-1"
                          maxLength={1000}
                          name="description"
                          value={supplier.description || ""}
                          onChange={handleInputChange}
                        />
                        <p>{t?.[l]?.["maximum_1000_characters"] || "Maximum 1000 Characters"}</p>
                      </div>
                    </div>
                    <div className="modal-footer-btn">
                      <button
                        type="button"
                        className="btn btn-cancel me-2"
                        data-bs-dismiss="modal"
                      >
                        {t?.[l]?.["cancel"] || "Cancel"}
                      </button>
                      <button type="submit" className="btn btn-submit">
                        {t?.[l]?.["save"] || "Save"}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Edit Supplier */}
    </div>
  );
};

export default UpdateSupplierModal;
